import React from 'react';
import {Route} from 'react-router-dom';
import {connect} from 'react-redux';
import {LoadCompanyEpic} from '../actions/auth.actions';

let mapDispatchToProps = (dispatch) => ({ 
    getCompany: (id) => dispatch(LoadCompanyEpic(id))
  });

let mapStateToProps = ({authEndpoint, nav},{match}) => {
  let company = null;
  if (authEndpoint.company) {
    //User is logged in for a specific company. 
    company = authEndpoint.companyData;
  } else if (authEndpoint.companyData) {
    //User is logged in with IQMetrix account, check if we already have the company data, otherwise null and force a load on mount.
    if(authEndpoint.companyData._id === nav.selectedCompany) {
      company = authEndpoint.companyData;
    }
  } 
  return {
    loadingInProgress: authEndpoint.fetchInProgress,
    company,
    companyId: authEndpoint.company? authEndpoint.company : nav.selectedCompany
  };
}

class FeatureRoute extends React.Component {

  componentDidMount(){
    if (!this.props.loadingInProgress && !this.props.company) {
        this.props.getCompany(this.props.companyId);
    }
  }

  render() {
    let hasAccess = false;
    if (this.props) {
      let company = this.props.company;
    
      if (company){ 
        hasAccess = this.props.features.reduce((valid, feature) => {
          return valid && company.features[feature]
        }, true);
      }
    }


    let {component: Component, features, company, companyId, loadingInProgress, ...rest} = this.props;
    return (
      <Route
        {...rest}
        render={(props) => hasAccess === true
          ? <Component {...props} />
          : <span>Not Found</span>}
      />
    );
  }
}

class FeatureContentComponent extends React.Component {
  
  render() {
    let hasAccess = false;
    if (this.props) {
      let company = this.props.company;
      console.log(company);
      if (company){ 
        hasAccess = this.props.features.reduce((valid, feature) => {
          return valid && company.features[feature]
        }, true);
      }
    }
    return hasAccess? <div>{this.props.children}</div>:<span></span>;


  }
}


export let FeatureContent = connect(mapStateToProps)(FeatureContentComponent);
export default connect(mapStateToProps, mapDispatchToProps)(FeatureRoute);


// WEBPACK FOOTER //
// ./src/components/FeatureRoute.js